export function siteOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }
  return 'https://canvasmemories.pages.dev';
}

export function campaignUrl(domain) {
  const slug = String(domain || '').replace(/^\/+|\/+$/g, '');
  return slug ? `${siteOrigin()}/${slug}/` : `${siteOrigin()}/{domain}/`;
}

export function proposeDomain(length = 16) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const bytes = crypto.getRandomValues(new Uint8Array(length));
  return Array.from(bytes, (b) => chars[b % chars.length]).join('');
}
